import * as modal from "../../util/modal.ts";
import * as amplify from "../../util/amplify.ts";
import * as i18n from "../../i18n.ts";
import {getCache,setCurrentBudget,getCurrentBudget,buildTransactionList,buildSummary} from "../../server/objects/BudgetBeans.ts";
import * as Html from "../../util/Html.ts";
import * as CustomInput from "../../util/CustomInput.ts";

import TPL_editlimit from "../../budget/budget_limit.mustache";
import TPL_catlimit from "../../budget/modal_categorieslimit.mustache";

export {openCategoryLimitModal,openLimitModal}

const {budgetCache,budgetCategoryCache,budgetPaymentMethodCache,budgetTransactionCache} = getCache();

function openCategoryLimitModal(budgetBean: any): void {
  let
    items = budgetCategoryCache.filtered().filter((cat: any)=>cat.budgetTransactionType==='EXPENSE').map((category: any)=>{return {
      metaId:category.metaId,
      category:category,
      limit:budgetBean.budgetCategoryLimits[category.metaId]||0,
      currencyCode:budgetBean.currencyCode
      }}),
    catLimitModal = modal.openDomModal(TPL_catlimit,{
      items:items,
      budgetLimit:budgetBean.budgetLimit}),
    percentNumber = catLimitModal.querySelector('.percentNumber') as HTMLElement,
    rawNumber = catLimitModal.querySelector('.rawNumber') as HTMLElement,
    percentBar = catLimitModal.querySelector('.percentBar') as HTMLElement,
    leftNumber = catLimitModal.querySelector('.leftNumber') as HTMLElement;
  function getTotal(): number {
    var total = 0;
    const inputs = catLimitModal.querySelectorAll<HTMLInputElement>('input[type=amount]');
    inputs.forEach((input: HTMLInputElement) => {
      const val = CustomInput.getAmountValue(input);
      total += val;
      CustomInput.setAmountValue(input, val);
    });
    return total;
  }
  function updateCategoryUI(): void {
    var
      total = getTotal(),
      max = budgetBean.budgetLimit,
      percent = 100*total/max,
      left = max-total;
    percentNumber.innerHTML = i18n.get("budgetlimit.percentset",percent.toFixed(0)+'%');
    const percentBarSpan = percentBar.querySelector('span') as HTMLElement;
    if (percentBarSpan) {
      percentBarSpan.style.width = percent.toFixed(1)+'%';
      percentBarSpan.style.backgroundColor = percent>100?"red":"var(--fwPrimary)";
    }
    rawNumber.innerHTML = budgetBean.formatAmount( total)+ '/'+budgetBean.formatAmount(max);
    if(left>=0){
      leftNumber.innerHTML = i18n.get("budgetlimit.lefttoallocate",budgetBean.formatAmount(left));
    }else{
      leftNumber.innerHTML = i18n.get("budgetlimit.overallocated",budgetBean.formatAmount(-left));
    }

    //submitButton.prop('disabled',percent>100)
  }
  updateCategoryUI()
  catLimitModal.addEventListener('change', (e: Event) => {
    const target = e.target as HTMLElement;
    if (target.matches('input[type=amount]')) {
      updateCategoryUI();
    }
  });
  catLimitModal.addEventListener('focus', (e: Event) => {
    const target = e.target as HTMLElement;
    if (target.matches('input[type=amount]')) {
      (target as HTMLInputElement).select();
    }
  }, true);

  const catLimitForm = catLimitModal.querySelector('form') as HTMLFormElement;
  catLimitForm.addEventListener('submit', function(event: Event){
    event.preventDefault();
    event.stopImmediatePropagation();
    event.stopPropagation();
    var
      total = getTotal(),
      budgetCategoryLimits: Record<string, number> = {};
      const inputs = catLimitModal.querySelectorAll<HTMLInputElement>('input[type=amount]');
      inputs.forEach((input: HTMLInputElement) => {
        const metaId = Html.getDomMetaId(input);
        if (metaId) {
          budgetCategoryLimits[metaId] = CustomInput.getAmountValue(input);
        }
      });

    if(total>budgetBean.budgetLimit){
      modal.ask({
        title:"budgetlimit.exceededtitle",
        message:i18n.get("budgetlimit.exceededtext",{budgetLimit:budgetBean.formatAmount(budgetBean.budgetLimit),budgetLimitTarget:budgetBean.formatAmount(total),budgetLimitExcess:budgetBean.formatAmount(total-budgetBean.budgetLimit)}),
        lottie:"images/lottie/face_with_monocle.json",
        button:[
          {title:"actions.proceed",onclick:function(){
            budgetBean.budgetLimit=total;
            budgetBean.budgetLimitCategoryActive = true;
            budgetBean.budgetCategoryLimits = budgetCategoryLimits;
            amplify.publish("budgetmodified");
            modal.closeDomModal();}},
          {title:"actions.cancel",class:"secondary"}
        ]
      })
    }else{
      budgetBean.budgetCategoryLimits = budgetCategoryLimits;
      budgetBean.budgetLimitCategoryActive = true;
      amplify.publish("budgetmodified");
      modal.closeDomModal();
    }
  })
  catLimitModal.onClose =function(){
    if(getTotal()>budgetBean.budgetLimit){
      budgetBean.budgetLimitCategoryActive = false;
     }else{
      budgetBean.budgetLimitCategoryActive = true;
    }
  }
}

function openLimitModal(budgetBean: any, wanachangeInfo?: any): void {
  var
      limitModal = modal.openDomModal(TPL_editlimit,{currencyCode:budgetBean.currencyCode,budgetLimit:budgetBean.budgetLimit,wanachangeInfo:wanachangeInfo});

    setTimeout(function(){
      const input = limitModal.querySelector('input') as HTMLInputElement;
      if (input) input.select();
    }, 100); //the time for widgets to execute
    const limitForm = limitModal.querySelector('form') as HTMLFormElement;
    limitForm.addEventListener('submit', function(this: HTMLFormElement, event: Event){
      event.preventDefault();
      const input = this.querySelector('input') as HTMLInputElement;
      var value = CustomInput.getAmountValue(input);
      if(value===0){
        modal.ask({
          title:"budgetlimit.limit0",
          message:"budgetlimit.limit0text",
          lottie:"images/lottie/face_with_monocle.json",
          button:[
            {class:'negative',title:'actions.disable',onclick:function(){
              budgetBean.budgetLimitActive=false;
              amplify.publish("budgetmodified");
              modal.closeDomModal();
            }},
            {class:'secondary',title:'actions.cancel',onclick:function(){
              const input = limitModal.querySelector('input') as HTMLInputElement;
              if (input) input.select();
            }}
          ]
        })
      }else{
        budgetBean.budgetLimitActive=true;
        budgetBean.budgetLimit = value;
        amplify.publish("budgetmodified");
        modal.closeDomModal();
        modal.ask({
          title:"budgetlimit.askcategory",
          message:"budgetlimit.askcategorytext",
          lottie:"images/lottie/face_with_monocle.json",
          button:[
            {title:'budgetlimit.askcategorybutton',onclick:function(){openCategoryLimitModal(budgetBean)}},
            {class:'secondary',title:'actions.later'}
          ]
        })
      }
    });
}
